import {closeWebView} from '@zzng/common/scheme/web';

import {HeaderButtonCommonProps} from '@/shared/components/Header';
import {TIARA_ACTION} from '@/shared/constants/tiara';

const CloseButton = ({onClick = closeWebView, trackEvent}: HeaderButtonCommonProps) => {
  return (
    <button
      type="button"
      className="btn_close"
      onClick={(e) => {
        trackEvent({action: TIARA_ACTION.CLOSE_CLICK});
        onClick(e);
      }}
    >
      <span className="icon icon_close">페이지 닫기</span>
    </button>
  );
};
export default CloseButton;
